module.exports = __webpack_public_path__ + "static/media/ranQiGuoClassroom.4756ea40.png";